import { useState, useEffect } from "react";
import asavault_logo from "../../assets/Images/asavaultlogo.png";
import { useNavigate } from "react-router-dom";
import "../../assets/css/style.css";
import { useAsaSession, useIsLoading, useAsaSessionPagesMutation, useBackButton } from '../../services/AsaSessionServices'

import {  useSubscriptionsPlans } from '../../services/AsaApiServices'
import { useTranslation } from "react-i18next";
import { IAsaSession, Plan, SessionPage } from "../../types/types";
/*
interface ExtractedParams {
  request?: string | null;
  token?: string | null;
  asaFintechCode?: string | null;
  asaFintechApplicationCode?: string | null;
  asaConsumerCode?: string | null;
  SubscriptionPlanCode?: string | null;
  IsNewSubscription?: string | null;
  IsTrialEligible?: string | null;
  Amount?: string | null;
  CouponCode?: string | null;
  PrevSubscriptionPlanCode?: string | null;
  redirecturl?: string | null;
  redirecturlonError?: string | null;
}
*/
const Authenticate = () => {
  const [isLoading, ] = useIsLoading();
  const { t } = useTranslation();
  const { data: session } = useAsaSession()
  const sessionMutation = useAsaSessionPagesMutation()
  const { data: subscriptionsPlans } = useSubscriptionsPlans()
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const handleBackClick = useBackButton()


  const [statusText, setStatusText] = useState("Authenticating...");
  //const [extractedParams, setExtractedParams] = useState<ExtractedParams>({});
 
  const updateSessiongoal = async (
    plan: Plan | undefined,
    pageUrl: string | undefined
  ) => {


    const sessionToUpdate: IAsaSession = { ...session } as IAsaSession
    sessionToUpdate.sessionPages = undefined
    const sessionpages = [] as SessionPage[]
    sessionpages.push({
      pageNumber: 2,
      pageName: "GOALS PLANS",
      pageTitle: "Select Package",
      pageDescription: "Select Package",
      pageUrl: pageUrl??"/Authenticate",
      pageStatusMessage: "INCOMPLETE",
      pageData: JSON.stringify(plan)
    } as SessionPage)
   
    try {

      const response = await sessionMutation.mutateAsync({ asaSession: sessionToUpdate, extraPages: sessionpages })

      return response;
    } catch (error) {

      console.error("Error updating session:", error);

    }
  };
  useEffect( () => {
    if(!!!session || isError || !!!subscriptionsPlans) 
      return;
    var error;
    const targetPage = session?.sessionPages?.find(page => page.pageNumber === 99 || page.pageName === "FintechBillingPage" );
    if(!!!targetPage){
      error="Target page not found in session pages.";
    }
    const targetPageData = targetPage?.pageData ? JSON.parse(targetPage.pageData) : null;
    const targetPlanCode = targetPageData?.SubscriptionPlanCode;
    const targetPlan=subscriptionsPlans?.find(plan => plan.subscriptionPlanCode?.toString() === targetPlanCode?.toString()  );

    if(!!!targetPlan){
      error=error ??"Target plan not found in subscriptions plans."
    }
    if(!!error){
       setStatusText(error)
       setIsError(true);
       return
    }
 
    const processPayment=async () => {
          try {
            setStatusText("Processing payment subscriptions...");
            const response = await updateSessiongoal(targetPlan,targetPage?.pageUrl);
            navigate("/subscriptionpayment");
          } catch (error) {
            setStatusText("Error during authentication.")
            setIsError(true);
          }
     };
     setTimeout(() => {
       processPayment();
     }, 500);

  }, [session,subscriptionsPlans]);

  return (
    <div className="flex bg-theme asavault_logo flex-col items-center justify-center h-screen">
      <img src={asavault_logo} alt="ASA Vault Logo" className="h-16 mb-4" />
      <p className="text-base text-white poppins-medium mb-2">{statusText}</p>
      {isLoading && (
        <div className="animate-spin h-8 w-8 border-t-2 border-b-2 border-white-900 rounded-full"></div>
      )}
      {isError && 
        <button
          onClick={handleBackClick}
          className="bg-white poppins-semibold text-purple-600 py-2 px-4 rounded-md shadow-md hover:bg-purple-600 hover:text-white transition duration-300"
        >
          {t("backToAsavaultApp")}
        </button>
     }
    </div>
  );
};

export default Authenticate;
